import React, { useRef, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';


function StatutePage() {


    const initialLoad = useRef(true);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    useEffect(() => {
        if (initialLoad.current) {
            scrollToTop();
            initialLoad.current = false;
        }
    }, []);

  return (
    <div>
    <Helmet>
        <title>Статут «За заслуги в индустрии красоты»</title>
        <meta
        name="description"
        content="Статут почетного вручения медали «За заслуги в индустрии красоты» является высшей наградой Некоммерческой организации Международной Ассоциации Красоты и Ухода"
        />
        <link rel="canonical" href="https://iabc-association.com/statutepage"/>
      </Helmet>
    <div className="documents-wrapper mt">
        <div className="text-center">
        <div className="page-title">Устав</div>
        <div className="awards-title">Почетного вручения медали «За заслуги в индустрии красоты»</div>
        <div className="medal-text-left">        
        <p className="page-subtext">Утвержден Общим собранием членов Международной </p>
        <p className="page-subtext">Ассоциации красоты и ухода "IABC"</p>
        <p className="page-text">Протокол № 12 от 1 сентября  2019 года</p>
        <p className="page-text mb-60">г. Москва</p></div>

        </div>
        <p className="page-text">Отличительная медаль «За заслуги в индустрии красоты» является высшей наградой Некоммерческой организации Международной Ассоциации Красоты и Ухода</p>
        <p className="page-subtext">Отличительной медалью «За заслуги в индустрии красоты» награждаются мастера за</p>
        <ul class="custom-list">
          <li>Высокий профессионализм в сфере красоты;</li>
          <li>Активную и результативную деятельность в распространении и развитии индустрии красоты;</li>
          <li>Значительный вклад в развитие и популяризацию красоты как научной области или практического опыта в индивидуальных и коммерческих проектах;</li>
          <li>Значимый личный вклад в развитие социально-ориентированного рынка красоты.</li>
        </ul>
        <p className="page-subtext">Награждение медалью «За заслуги в индустрии красоты» происходит в следующих областях:</p>
        <ul class="custom-list">
          <li>Инновации в индустрии красоты</li>
          <li>Лидерство в создании образов</li>
          <li>Социальный и этический подход в красоте</li>
          <li>Международный вклад в индустрию красоты</li>
          <li>Образование и наставничество в области красоты</li>
        </ul>
        <p className="page-text">Отличительная медаль «За заслуги в индустрии красоты» вручается на постоянной основе, без права лишения награды.</p>
        <p className="page-text">Инициатива по предложению кандидатур на награждение отличительной медалью «За заслуги в индустрии красоты» принадлежит Мастерам, обладающим отличительным знаком, - действительным и почетным членам Международной Ассоциации Мастеров Красоты.</p>
        <p className="page-text">Для принятия кандидатуры к рассмотрению Комитетом по Званиям и Наградам необходимо получить рекомендации не менее чем от ДВУХ рекомендателей. Инициаторы предложения должны предоставить Комитету по Званиям официальное письменное обоснование в пользу кандидатуры.</p>
        <p className="page-text">Из предложенных действительными членами Ассоциации кандидатур Комитет по Званиям и Наградам формирует список из пяти кандидатур в год.</p>
        <p className="page-text">Окончательное решение по кандидатуре награждаемого отличительной медалью «За заслуги в индустрии красоты» принимается на заседании Совета Международной Ассоциации Красоты и Ухода.</p>
        <p className="page-text">Награждение отличительной медалью «За заслуги в индустрии красоты» подтверждается именным номерным Свидетельством о награждении на русском языке, заверенным печатью Некоммерческого Партнерства Международной Ассоциации Красоты и Ухода и подписью Президента Ассоциации.</p>
        <p className="page-text">Отличительная медаль «За заслуги в индустрии красоты» содержит зарегистрированный логотип Некоммерческого Сообщества Международной Ассоциации Красоты и Ухода, являющийся собственностью НС Международной Ассоциации Красоты и Ухода, охраняемый в соответствии с законодательством Российской Федерации.</p>
        <p className="page-text">Отличительная медаль «За заслуги в индустрии красоты» изготавливается и распространяется только с разрешения Совета Ассоциации Мастеров, соблюдая все требования Устава, Положений и Правил о проведении заседаний Совета.</p>
        <p className="page-text">Награжденному отличительной медалью «За заслуги в индустрии красоты» предоставляются следующие права, независимо от членства в Международной Ассоциации Красоты и Ухода:</p>
        <ul class="custom-list">
          <li>Вступление в члены Международной Ассоциации Красоты и Ухода по желанию;</li>
          <li>Освобождение от вступительного взноса;</li>
          <li>Участие без предварительного приглашения во всех открытых и бесплатных мероприятиях Международной Ассоциации Красоты и Ухода;</li>
          <li>Размещение информации в электронных и печатных изданиях Международной Ассоциации Мастеров Красоты наравне с действительными членами Международной Ассоциации Красоты и Ухода</li>
        </ul>
    </div>
    </div>
  );
}

export default StatutePage;
